import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import SelectField from 'eventbrite_design_system/inputField/SelectField';
import Checkbox from 'eventbrite_design_system/checkbox/Checkbox';
import withTooltip from 'eventbrite_design_system/tooltip/withTooltip';
import Icon from 'eventbrite_design_system/icon/Icon';

import InfoChunkySvg from 'eventbrite_design_system/iconography/icons/InfoChunky';

import {
    setExperimentOverride,
    setShouldShowDebugOutput,
} from '../actions/admin';

const IconWithTooltip = withTooltip(Icon);

const AdminSearchSubHeader = (props) => {
    return props.isStaff ? (
        <div className="search-admin-subheader eds-bg-color--grey-200">
            <div className="eds-text-color--primary-brand eds-text-weight--heavy eds-text-bl eds-align--center">
                Staff-only debug tool
                <IconWithTooltip
                    type={<InfoChunkySvg />}
                    size="small"
                    color="grey-600"
                    tooltipId="tooltip-info-1"
                    tooltipStyle="basic"
                    tooltipText="Run a search after adding #debug to the URL to see debug output"
                />
            </div>
            <div className="eds-align--center">
                <Checkbox
                    id="admin-debug-output-theckbox"
                    onChange={props.setShouldShowDebugOutput}
                    value={props.shouldShowDebugOutput}
                    defaultValue={props.shouldShowDebugOutput}
                >
                    Show debug output
                    <IconWithTooltip
                        type={<InfoChunkySvg />}
                        size="small"
                        color="grey-600"
                        tooltipId="tooltip-info-2"
                        tooltipStyle="basic"
                        tooltipText="Mainly useful for hiding debug output when overriding the experiment"
                    />
                </Checkbox>
            </div>
            <div className="eds-align--center">
                <SelectField
                    label="Experiment"
                    values={_.range(-10, 5).map((i) => ({
                        value: 'search_exp_' + i,
                        display: 'search_exp_' + i,
                    }))}
                    value={props.experimentOverride.experimentName}
                    onChange={(experimentName) =>
                        props.setExperimentOverride({
                            experimentName,
                            variant: props.experimentOverride.variant,
                        })
                    }
                />
                <div className="eds-l-mar-left-4">
                    <SelectField
                        style="basic"
                        label="Variant"
                        values={[
                            { value: 'A', display: 'A' },
                            { value: 'B', display: 'B' },
                            { value: 'C', display: 'C' },
                            { value: 'D', display: 'D' },
                        ]}
                        value={props.experimentOverride.variant}
                        onChange={(variant) =>
                            props.setExperimentOverride({
                                experimentName:
                                    props.experimentOverride.experimentName,
                                variant,
                            })
                        }
                    />
                </div>
            </div>
        </div>
    ) : null;
};

const _mapStateToProps = (state) => ({
    experiments: state.app.experiments,
    experimentOverride: state.admin.experimentOverride,
    shouldShowDebugOutput: state.admin.shouldShowDebugOutput,
    isStaff: state.user.isStaff,
});

const _mapDispatchToProps = (dispatch) => ({
    setExperimentOverride: (...args) =>
        dispatch(setExperimentOverride(...args)),
    setShouldShowDebugOutput: (...args) =>
        dispatch(setShouldShowDebugOutput(...args)),
});

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(AdminSearchSubHeader);
